$.fn.ContentShare = function() {
  let self = this
  self.copied_timeout = undefined

  if (self.data('content-share')) {
    return self.data('content-share')
  }

  self.click_outside = function(e) {
    if (!$(e.target).hasClass('content-share') && !$(e.target).closest('.content-share').length) {
      self.attr('aria-expanded', 'false')
      self.find('.visible').removeClass('visible')
      $(window).off('click', self.click_outside)
      $('body').removeClass('--content-share')
      clearTimeout(self.copied_timeout)
    }
  }

  self.toggle_expand = function() {
    if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'false') {
      $(window).off('click', self.click_outside).on('click', self.click_outside)
      self.attr('aria-expanded', 'true')
      $('body').addClass('--content-share')
    } else if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'true') {
      self.attr('aria-expanded', 'false')
      self.find('.visible').removeClass('visible')
      $(window).off('click', self.click_outside)
      $('body').removeClass('--content-share')
      clearTimeout(self.copied_timeout)
    }
  }

  self.copy_link = function() {
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('span.copied').addClass('visible').find('> span').text(visagesregionaux_l10n.COPIED_LINK)
    self.copied_timeout = setTimeout(function() {
      self.find('span.copied').removeClass('visible')
    }, 3200)
    return false
  }

  return function() {
    self.find('.content-share__button').on('click', self.toggle_expand)
    self.find('.content-share__close-btn').on('click', self.toggle_expand)
    self.find('.content-share__action--copy-link').on('click', self.copy_link)
    self.data('content-share', self)
    return self
  }()
}
